var exports = {
  "k": "EmojiPickerSearchBar.module__container___V2VDOW",
};

module.exports = exports;
